import { render, staticRenderFns } from "./StatusConfig.vue?vue&type=template&id=3f617184&scoped=true"
import script from "./StatusConfig.vue?vue&type=script&lang=js"
export * from "./StatusConfig.vue?vue&type=script&lang=js"
import style0 from "./StatusConfig.vue?vue&type=style&index=0&id=3f617184&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f617184",
  null
  
)

export default component.exports